import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CustomMessageService, LocalStorageService, UtilService} from "library";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import {PermissionService} from "projects/store/src/app/services/permission.service";
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageKey, Permission} from "projects/store/src/app/enums";
import { ResponseHttpError, ResponseHttpSuccess } from "library";
import {HttpStatusCode} from "@angular/common/http";
import {catchError, EMPTY, tap} from "rxjs";

@Component({
  selector: 'app-commission-reports-commissions',
  templateUrl: './commission-reports-commissions.component.html',
  styleUrls: ['./commission-reports-commissions.component.scss']
})
export class CommissionReportsCommissionsComponent implements OnInit{
  listCommissionsOfUser: any;
  userData: UserData;
  role: any;
  idUser: string;
  idDistributor: string;
  listStore: any[] = [];
  selectedStore: string | undefined;
  @Input() year!: number;
  @Input() month!: number;
  @Output() onListCommissions = new  EventEmitter<any>

  constructor(private commissionsService: CommissionsService,
              private customMessageService: CustomMessageService,
              private permissionService: PermissionService,
              protected utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data);
    this.role = this.userData.user.role.code;
    this.idUser = this.userData.user.id;
    this.idDistributor = this.userData.distributor.id;
  }

  ngOnInit() {
    if (this.permissionService.checkPermission(Permission['Gestion.Comercial.Reportes.SeleccionTienda'])) {
      this.loadListStore(this.idDistributor);
    }else{
      this.loadCommissionsUser(this.idUser);
    }

  }
  loadCommissionsUser(idUser: any){
    this.utilService.enablePageLoading();
    this.commissionsService.getCommisionsOfUser(idUser, this.month, this.year).subscribe({
      next: (resp: ResponseHttpSuccess) =>{
        if (resp.status === HttpStatusCode.Ok){
          this.listCommissionsOfUser = resp.body.data.list.sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime())
            .map((commision: any) => {
              commision.status = commision.status.replaceAll('_', ' ')
              return commision;
            });
          this.onListCommissions.emit(this.listCommissionsOfUser);
          console.log(this.listCommissionsOfUser);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    })
  }

  loadListStore(idDealer: any) {
    this.utilService.enablePageLoading();
    this.commissionsService.getListStoreByDealer(idDealer).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.listStore = resp.body.data.list;
          this.selectedStore = this.listStore[0].id;
          this.loadCommissionsOneStore(this.selectedStore).subscribe({
            complete: () => {
              this.utilService.disablePageLoading();
            }
          });
        } else {
          this.customMessageService.responseNoticeHandler(resp);
          this.utilService.disablePageLoading();
        }
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });
  }

  loadCommissionsOneStore(idStore: any) {
    return this.commissionsService.getCommisionsOfStore(idStore, this.idUser, this.month, this.year).pipe(
      tap((resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.listCommissionsOfUser = resp.body.data.list;
          this.onListCommissions.emit(this.listCommissionsOfUser);
          console.log(this.listCommissionsOfUser);
        } else {
          this.customMessageService.responseNoticeHandler(resp);
        }
      }),
      catchError(error => {
        this.customMessageService.responseNoticeHandler(error);
        return EMPTY;
      })
    );
  }

  onChangeStore(idStore: any) {
    console.log(idStore);
    this.utilService.enablePageLoading();
    this.commissionsService.getCommisionsOfStore(idStore, this.idUser, this.month, this.year).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.listCommissionsOfUser = resp.body.data.list;
          this.onListCommissions.emit(this.listCommissionsOfUser);
          console.log(this.listCommissionsOfUser);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    })
  }

  protected readonly Permission = Permission;
}
